// extracted by mini-css-extract-plugin
export var wrapper = "OneMillionContainer_wrapper__Z9epD";